import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
import PatientIPSearch from "../PatientIPSearch";
function BiomedicalWasteManagement() {
    const [tab, setTab] = useState("entry");
    const [categories, setCategories] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [entries, setEntries] = useState([]);
    const [pickups, setPickups] = useState([]);
    const [incidents, setIncidents] = useState([]);
    const [patient, setPatient] = useState({});
    const [categoryForm, setCategoryForm] = useState({
        code: "", category: "", color: "", description: "", status: "ACTIVE"
    });
    const [form, setForm] = useState({
        category: "",
        color_code: "",
        department: "",
        ip_id: "",
        pat_id: "",
        patient_name: "",
        quantity: "",
        unit: "KG",
        storage_location: "",
        remarks: ""
    });
    const [pickup, setPickup] = useState({
        waste_no: "",
        vendor_name: "",
        vehicle_no: "",
        driver_name: "",
        category: "",
        quantity: "",
        unit: "KG",
        manifest_no: "",
        disposal_method: "",
        remarks: ""
    });
    const [incident, setIncident] = useState({
        department: "", incident_type: "", description: "", action_taken: "", reported_by: userName || ""
    });
    useEffect(() => {
        loadAllData();
    }, []);
    const loadAllData = () => {
        axios.get(`${baseUrl}biomedical-waste/categories/`)
            .then(r => setCategories(r.data || []));
        axios.get(`${baseUrl}add-dept/`)
            .then(r => setDepartments(r.data || []));
        axios.get(`${baseUrl}biomedical-waste/entries/`)
            .then(r => setEntries(r.data || []));
        axios.get(`${baseUrl}biomedical-waste/pickups/`)
            .then(r => setPickups(r.data || []));
        axios.get(`${baseUrl}biomedical-waste/incidents/`)
            .then(r => setIncidents(r.data || []));
    };
    const handleCategoryChange = e => {
        setCategoryForm(prev => ({
            ...prev, [e.target.name]: e.target.value
        }));
    };
    const saveCategory = async e => {
        e.preventDefault();
        if (!categoryForm.code.trim()) {
            Swal.fire("Required", "Enter category code.", "warning");
            return;
        }
        if (!categoryForm.category.trim()) {
            Swal.fire("Required", "Enter waste category.", "warning");
            return;
        }
        if (!categoryForm.color.trim()) {
            Swal.fire("Required", "Select waste colour.", "warning");
            return;
        }
        try {
            await axios.post(`${baseUrl}biomedical-waste/categories/`, {
                ...categoryForm, addedby: userName, ip_add: ipAddress, location: userLocation
            });
            await Swal.fire({
                title: "Category Saved",
                text: "Biomedical waste category created successfully.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false
            });
            setCategoryForm({
                code: "", category: "", color: "", description: "", status: "ACTIVE"
            });
            loadAllData();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", error?.response?.data?.error || "Unable to save category.", "error");
        }
    };
    const categoryColumns = [{
        field: "id", headerName: "ID", width: 70
    }, {
        field: "code", headerName: "Code", width: 150
    }, {
        field: "category", headerName: "Category", width: 220
    }, {
        field: "color", headerName: "Colour", width: 130
    }, {
        field: "description", headerName: "Description", width: 350
    }, {
        field: "status", headerName: "Status", width: 120
    }];
    // =========================================================
    // PATIENT SELECTION
    // =========================================================
    const selectPatient = data => {
        console.log("SELECTED PATIENT:", data);
        setPatient(data || {});
        const patientDepartment = data.department || data.department_name || data.dept_name || "";
        setForm(prev => ({
            ...prev,
            ip_id: data.ip_id || data.ipId || data.IP_ID || "",
            pat_id: data.pat_id || data.patId || data.patient_id || data.patientId || "",
            patient_name: data?.patient_name || data?.patient || data?.pat?.patient || "",
            department: patientDepartment
        }));
    };
    // =========================================================
    // CATEGORY SELECTION
    // =========================================================
    const selectCategory = e => {
        const categoryName = e.target.value;
        const selected = categories.find(item => item.category === categoryName);
        setForm(prev => ({
            ...prev, category: categoryName, color_code: selected?.color || ""
        }));
    };
    // =========================================================
    // WASTE ENTRY
    // =========================================================
    const submitWaste = async e => {
        e.preventDefault();
        if (!form.category) {
            Swal.fire("Required", "Please select waste category.", "warning");
            return;
        }
        if (!form.department) {
            Swal.fire("Required", "Please select department.", "warning");
            return;
        }
        if (!form.quantity || Number(form.quantity) <= 0) {
            Swal.fire("Required", "Enter valid quantity.", "warning");
            return;
        }
        try {
            const fd = new FormData();
            fd.append("waste_no", "BMW-" + Date.now());
            Object.keys(form).forEach(key => {
                fd.append(key, form[key]);
            });
            fd.append("status", "GENERATED");
            fd.append("addedby", userName);
            fd.append("ip_add", ipAddress);
            fd.append("location", userLocation);
            await axios.post(`${baseUrl}biomedical-waste/entries/`, fd);
            await Swal.fire({
                title: "Waste Recorded",
                text: "Biomedical waste generation recorded.",
                icon: "success",
                timer: 1600,
                showConfirmButton: false
            });
            setForm({
                category: "",
                color_code: "",
                department: "",
                ip_id: "",
                pat_id: "",
                patient_name: "",
                quantity: "",
                unit: "KG",
                storage_location: "",
                remarks: ""
            });
            loadAllData();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", error?.response?.data?.error || "Unable to save biomedical waste.", "error");
        }
    };
    // =========================================================
    // PICKUP WASTE SELECTION
    // =========================================================
    const selectPickupEntry = e => {
        const wasteNo = e.target.value;
        const selected = entries.find(item => item.waste_no === wasteNo);
        if (!selected) {
            setPickup({
                waste_no: "",
                vendor_name: "",
                vehicle_no: "",
                driver_name: "",
                category: "",
                quantity: "",
                unit: "KG",
                manifest_no: "",
                disposal_method: "",
                remarks: ""
            });
            return;
        }
        setPickup(prev => ({
            ...prev,
            waste_no: selected.waste_no,
            category: selected.category,
            quantity: selected.quantity,
            unit: selected.unit || "KG"
        }));
    };
    // =========================================================
    // PICKUP
    // =========================================================
    const submitPickup = async e => {
        e.preventDefault();
        if (!pickup.waste_no) {
            Swal.fire("Required", "Please select generated waste.", "warning");
            return;
        }
        if (!pickup.vendor_name) {
            Swal.fire("Required", "Please enter/select waste collection vendor.", "warning");
            return;
        }
        try {
            const fd = new FormData();
            fd.append("pickup_no", "BMW-PICK-" + Date.now());
            Object.keys(pickup).forEach(key => {
                fd.append(key, pickup[key]);
            });
            fd.append("status", "PICKED");
            fd.append("addedby", userName);
            fd.append("ip_add", ipAddress);
            await axios.post(`${baseUrl}biomedical-waste/pickups/`, fd);
            await Swal.fire({
                title: "Pickup Recorded",
                text: "Biomedical waste collection recorded.",
                icon: "success",
                timer: 1600,
                showConfirmButton: false
            });
            setPickup({
                waste_no: "",
                vendor_name: "",
                vehicle_no: "",
                driver_name: "",
                category: "",
                quantity: "",
                unit: "KG",
                manifest_no: "",
                disposal_method: "",
                remarks: ""
            });
            loadAllData();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", error?.response?.data?.error || "Unable to record pickup.", "error");
        }
    };
    // =========================================================
    // INCIDENT
    // =========================================================
    const submitIncident = async e => {
        e.preventDefault();
        if (!incident.department) {
            Swal.fire("Required", "Please select department.", "warning");
            return;
        }
        if (!incident.incident_type) {
            Swal.fire("Required", "Please select incident type.", "warning");
            return;
        }
        if (!incident.description.trim()) {
            Swal.fire("Required", "Please enter incident description.", "warning");
            return;
        }
        try {
            const fd = new FormData();
            fd.append("incident_no", "BMW-INC-" + Date.now());
            Object.keys(incident).forEach(key => {
                fd.append(key, incident[key]);
            });
            fd.append("status", "OPEN");
            fd.append("addedby", userName);
            await axios.post(`${baseUrl}biomedical-waste/incidents/`, fd);
            await Swal.fire({
                title: "Incident Recorded",
                text: "Biomedical waste incident has been recorded.",
                icon: "success",
                timer: 1600,
                showConfirmButton: false
            });
            setIncident({
                department: "", incident_type: "", description: "", action_taken: "", reported_by: userName || ""
            });
            loadAllData();
        } catch (error) {
            console.log(error);
            Swal.fire("Error", error?.response?.data?.error || "Unable to record incident.", "error");
        }
    };
    // =========================================================
    // COLUMNS
    // =========================================================
    const entryColumns = [{
        field: "waste_no", headerName: "Waste No", width: 180
    }, {
        field: "category", headerName: "Category", width: 180
    }, {
        field: "color_code", headerName: "Colour", width: 120
    }, {
        field: "department", headerName: "Department", width: 180
    }, {
        field: "ip_id", headerName: "IP ID", width: 140
    }, {
        field: "pat_id", headerName: "Patient ID", width: 150
    }, {
        field: "patient_name", headerName: "Patient", width: 180
    }, {
        field: "quantity", headerName: "Qty", width: 90
    }, {
        field: "unit", headerName: "Unit", width: 90
    }, {
        field: "status", headerName: "Status", width: 130
    }];
    const pickupColumns = [{
        field: "pickup_no", headerName: "Pickup No", width: 180
    }, {
        field: "waste_no", headerName: "Waste No", width: 180
    }, {
        field: "vendor_name", headerName: "Vendor", width: 200
    }, {
        field: "vehicle_no", headerName: "Vehicle", width: 140
    }, {
        field: "driver_name", headerName: "Driver", width: 160
    }, {
        field: "category", headerName: "Category", width: 170
    }, {
        field: "quantity", headerName: "Quantity", width: 100
    }, {
        field: "unit", headerName: "Unit", width: 90
    }, {
        field: "manifest_no", headerName: "Manifest", width: 160
    }, {
        field: "disposal_method", headerName: "Disposal", width: 180
    }, {
        field: "status", headerName: "Status", width: 120
    }];
    const incidentColumns = [{
        field: "incident_no", headerName: "Incident No", width: 180
    }, {
        field: "department", headerName: "Department", width: 180
    }, {
        field: "incident_type", headerName: "Type", width: 180
    }, {
        field: "reported_by", headerName: "Reported By", width: 160
    }, {
        field: "status", headerName: "Status", width: 120
    }];
    return (<section className="container-fluid mt-4">


        <h3 className="text-center bg-warning p-2">

            <i className="fa fa-recycle me-2"></i>

            Biomedical Waste Management

        </h3>


        {/* =================================================
                TABS
            ================================================= */}

        <div className="btn-group mb-3">
            <button
                className={`btn ${tab === "category" ? "btn-warning" : "btn-outline-warning"}`}
                onClick={() => setTab("category")}
            >
                <i className="fa fa-tags me-1"></i>

                Category Master
            </button>
            <button
                className={`btn ${tab === "entry" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setTab("entry")}
            >
                Waste Generation
            </button>


            <button
                className={`btn ${tab === "pickup" ? "btn-success" : "btn-outline-success"}`}
                onClick={() => setTab("pickup")}
            >
                Collection / Disposal
            </button>


            <button
                className={`btn ${tab === "incident" ? "btn-danger" : "btn-outline-danger"}`}
                onClick={() => setTab("incident")}
            >
                Incidents
            </button>


            <button
                className={`btn ${tab === "report" ? "btn-secondary" : "btn-outline-secondary"}`}
                onClick={() => setTab("report")}
            >
                Reports
            </button>

        </div>


        {/* =================================================
                WASTE GENERATION
            ================================================= */}

        {tab === "entry" && (<>

            <PatientIPSearch
                onSelect={selectPatient}
            />


            <div className="card shadow-sm mb-4">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">

                        <i className="fa fa-trash me-2"></i>

                        Biomedical Waste Generation

                    </h5>

                </div>


                <div className="card-body">


                    <form onSubmit={submitWaste}>

                        <div className="row">


                            <div className="col-md-3 mb-3">

                                <label>
                                    IP ID
                                </label>

                                <input
                                    className="form-control"
                                    value={form.ip_id}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label>
                                    Patient ID
                                </label>

                                <input
                                    className="form-control"
                                    value={form.pat_id}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label>
                                    Patient
                                </label>

                                <input
                                    className="form-control"
                                    value={form.patient_name}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-3 mb-3">

                                <label>
                                    Department
                                </label>

                                <select
                                    className="form-control"
                                    value={form.department}
                                    onChange={e => setForm(prev => ({
                                        ...prev, department: e.target.value
                                    }))}
                                >

                                    <option value="">
                                        Select Department
                                    </option>

                                    {departments.map((dept, index) => {
                                        const value = typeof dept === "string" ? dept : dept.name || dept.department || dept.department_name || "";
                                        return (<option
                                            key={dept.id || index}
                                            value={value}
                                        >
                                            {value}
                                        </option>);
                                    })}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    Waste Category
                                </label>

                                <select
                                    className="form-control"
                                    value={form.category}
                                    onChange={selectCategory}
                                >

                                    <option value="">
                                        Select Waste Category
                                    </option>

                                    {categories
                                        .filter(item => item.status === "ACTIVE" || !item.status)
                                        .map(item => (<option
                                            key={item.id}
                                            value={item.category}
                                        >

                                            {item.code}
                                            {" - "}
                                            {item.category}

                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-2 mb-3">

                                <label>
                                    Colour
                                </label>

                                <input
                                    className="form-control"
                                    value={form.color_code}
                                    readOnly
                                />

                            </div>


                            <div className="col-md-2 mb-3">

                                <label>
                                    Quantity
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    className="form-control"
                                    value={form.quantity}
                                    onChange={e => setForm(prev => ({
                                        ...prev, quantity: e.target.value
                                    }))}
                                />

                            </div>


                            <div className="col-md-2 mb-3">

                                <label>
                                    Unit
                                </label>

                                <select
                                    className="form-control"
                                    value={form.unit}
                                    onChange={e => setForm(prev => ({
                                        ...prev, unit: e.target.value
                                    }))}
                                >

                                    <option value="KG">
                                        KG
                                    </option>

                                    <option value="GRAM">
                                        Gram
                                    </option>

                                    <option value="NUMBER">
                                        Number
                                    </option>

                                </select>

                            </div>


                            <div className="col-md-2 mb-3">

                                <label>
                                    Storage
                                </label>

                                <select
                                    className="form-control"
                                    value={form.storage_location}
                                    onChange={e => setForm(prev => ({
                                        ...prev, storage_location: e.target.value
                                    }))}
                                >

                                    <option value="">
                                        Select Storage
                                    </option>

                                    <option value="BMW STORAGE - 01">
                                        BMW Storage - 01
                                    </option>

                                    <option value="BMW STORAGE - 02">
                                        BMW Storage - 02
                                    </option>

                                </select>

                            </div>


                            <div className="col-md-10 mb-3">

                                <label>
                                    Remarks
                                </label>

                                <input
                                    className="form-control"
                                    value={form.remarks}
                                    onChange={e => setForm(prev => ({
                                        ...prev, remarks: e.target.value
                                    }))}
                                />

                            </div>


                            <div className="col-md-2 mb-3 d-flex align-items-end">

                                <button
                                    type="submit"
                                    className="btn btn-success w-100"
                                >

                                    <i className="fa fa-save me-1"></i>

                                    Record Waste

                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>


            <DataGrid

                rows={entries}

                columns={entryColumns}

                autoHeight

                slots={{
                    toolbar: GridToolbar
                }}

                pageSizeOptions={[10, 25, 50]}

            />

        </>)}


        {/* =================================================
                PICKUP
            ================================================= */}

        {tab === "pickup" && (<div className="card shadow-sm">


            <div className="card-header bg-success text-white">

                <h5 className="mb-0">

                    <i className="fa fa-truck me-2"></i>

                    Biomedical Waste Collection / Disposal

                </h5>

            </div>


            <div className="card-body">


                <form onSubmit={submitPickup}>

                    <div className="row">


                        <div className="col-md-6 mb-3">

                            <label>
                                Generated Waste Record
                            </label>

                            <select
                                className="form-control"
                                value={pickup.waste_no}
                                onChange={selectPickupEntry}
                            >

                                <option value="">
                                    Select Generated Waste
                                </option>

                                {entries
                                    .filter(item => item.status === "GENERATED" || item.status === "STORED")
                                    .map(item => (<option
                                        key={item.id}
                                        value={item.waste_no}
                                    >

                                        {item.waste_no}
                                        {" | "}
                                        {item.category}
                                        {" | "}
                                        {item.quantity}
                                        {" "}
                                        {item.unit}

                                    </option>))}

                            </select>

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Category
                            </label>

                            <input
                                className="form-control"
                                value={pickup.category}
                                readOnly
                            />

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Quantity
                            </label>

                            <input
                                className="form-control"
                                value={pickup.quantity}
                                readOnly
                            />

                        </div>


                        <div className="col-md-2 mb-3">

                            <label>
                                Unit
                            </label>

                            <input
                                className="form-control"
                                value={pickup.unit}
                                readOnly
                            />

                        </div>


                        <div className="col-md-4 mb-3">

                            <label>
                                Vendor
                            </label>

                            <input
                                className="form-control"
                                value={pickup.vendor_name}
                                onChange={e => setPickup(prev => ({
                                    ...prev, vendor_name: e.target.value
                                }))}
                                placeholder="BMW authorised vendor"
                            />

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Vehicle No
                            </label>

                            <input
                                className="form-control"
                                value={pickup.vehicle_no}
                                onChange={e => setPickup(prev => ({
                                    ...prev, vehicle_no: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Driver
                            </label>

                            <input
                                className="form-control"
                                value={pickup.driver_name}
                                onChange={e => setPickup(prev => ({
                                    ...prev, driver_name: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Manifest No
                            </label>

                            <input
                                className="form-control"
                                value={pickup.manifest_no}
                                onChange={e => setPickup(prev => ({
                                    ...prev, manifest_no: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-3 mb-3">

                            <label>
                                Disposal Method
                            </label>

                            <select
                                className="form-control"
                                value={pickup.disposal_method}
                                onChange={e => setPickup(prev => ({
                                    ...prev, disposal_method: e.target.value
                                }))}
                            >

                                <option value="">
                                    Select Method
                                </option>

                                <option value="INCINERATION">
                                    Incineration
                                </option>

                                <option value="AUTOCLAVE">
                                    Autoclave
                                </option>

                                <option value="SHREDDING">
                                    Shredding
                                </option>

                                <option value="DEEP BURIAL">
                                    Deep Burial
                                </option>

                                <option value="CHEMICAL TREATMENT">
                                    Chemical Treatment
                                </option>

                                <option value="OTHER">
                                    Other
                                </option>

                            </select>

                        </div>


                        <div className="col-md-6 mb-3">

                            <label>
                                Remarks
                            </label>

                            <input
                                className="form-control"
                                value={pickup.remarks}
                                onChange={e => setPickup(prev => ({
                                    ...prev, remarks: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-3 mb-3 d-flex align-items-end">

                            <button
                                type="submit"
                                className="btn btn-success w-100"
                            >

                                <i className="fa fa-truck me-1"></i>

                                Record Pickup

                            </button>

                        </div>

                    </div>

                </form>


                <hr/>


                <DataGrid

                    rows={pickups}

                    columns={pickupColumns}

                    autoHeight

                    slots={{
                        toolbar: GridToolbar
                    }}

                    pageSizeOptions={[10, 25, 50]}

                />

            </div>

        </div>)}


        {/* =================================================
                INCIDENT
            ================================================= */}

        {tab === "incident" && (<div className="card shadow-sm">


            <div className="card-header bg-danger text-white">

                <h5 className="mb-0">

                    <i className="fa fa-triangle-exclamation me-2"></i>

                    Biomedical Waste Incident

                </h5>

            </div>


            <div className="card-body">


                <form onSubmit={submitIncident}>

                    <div className="row">


                        <div className="col-md-4 mb-3">

                            <label>
                                Department
                            </label>

                            <select
                                className="form-control"
                                value={incident.department}
                                onChange={e => setIncident(prev => ({
                                    ...prev, department: e.target.value
                                }))}
                            >

                                <option value="">
                                    Select Department
                                </option>

                                {departments.map((dept, index) => {
                                    const value = typeof dept === "string" ? dept : dept.name || dept.department || dept.department_name || "";
                                    return (<option
                                        key={dept.id || index}
                                        value={value}
                                    >
                                        {value}
                                    </option>);
                                })}

                            </select>

                        </div>


                        <div className="col-md-4 mb-3">

                            <label>
                                Incident Type
                            </label>

                            <select
                                className="form-control"
                                value={incident.incident_type}
                                onChange={e => setIncident(prev => ({
                                    ...prev, incident_type: e.target.value
                                }))}
                            >

                                <option value="">
                                    Select Incident
                                </option>

                                <option value="NEEDLE STICK INJURY">
                                    Needle Stick Injury
                                </option>

                                <option value="SPILL">
                                    Spill
                                </option>

                                <option value="WRONG SEGREGATION">
                                    Wrong Segregation
                                </option>

                                <option value="EXPOSURE">
                                    Exposure
                                </option>

                                <option value="CONTAINER DAMAGE">
                                    Container Damage
                                </option>

                                <option value="OTHER">
                                    Other
                                </option>

                            </select>

                        </div>


                        <div className="col-md-4 mb-3">

                            <label>
                                Reported By
                            </label>

                            <input
                                className="form-control"
                                value={incident.reported_by}
                                onChange={e => setIncident(prev => ({
                                    ...prev, reported_by: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-6 mb-3">

                            <label>
                                Description
                            </label>

                            <textarea
                                className="form-control"
                                rows="4"
                                value={incident.description}
                                onChange={e => setIncident(prev => ({
                                    ...prev, description: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-6 mb-3">

                            <label>
                                Action Taken
                            </label>

                            <textarea
                                className="form-control"
                                rows="4"
                                value={incident.action_taken}
                                onChange={e => setIncident(prev => ({
                                    ...prev, action_taken: e.target.value
                                }))}
                            />

                        </div>


                        <div className="col-md-3">

                            <button
                                type="submit"
                                className="btn btn-danger w-100"
                            >

                                <i className="fa fa-save me-1"></i>

                                Report Incident

                            </button>

                        </div>

                    </div>

                </form>


                <hr/>


                <DataGrid

                    rows={incidents}

                    columns={incidentColumns}

                    autoHeight

                    slots={{
                        toolbar: GridToolbar
                    }}

                    pageSizeOptions={[10, 25, 50]}

                />

            </div>

        </div>)}
        {/* =================================================
    CATEGORY MASTER
================================================= */}

        {tab === "category" && (<div className="card shadow-sm">

            <div className="card-header bg-warning">

                <h5 className="mb-0">

                    <i className="fa fa-recycle me-2"></i>

                    Biomedical Waste Category Master

                </h5>

            </div>


            <div className="card-body">


                <form onSubmit={saveCategory}>

                    <div className="row">


                        {/* CODE */}

                        <div className="col-md-2 mb-3">

                            <label>
                                Code
                            </label>

                            <input
                                className="form-control"
                                name="code"
                                value={categoryForm.code}
                                onChange={handleCategoryChange}
                                placeholder="BMW-YELLOW"
                                required
                            />

                        </div>


                        {/* CATEGORY */}

                        <div className="col-md-3 mb-3">

                            <label>
                                Category
                            </label>

                            <input
                                className="form-control"
                                name="category"
                                value={categoryForm.category}
                                onChange={handleCategoryChange}
                                placeholder="Yellow Category"
                                required
                            />

                        </div>


                        {/* COLOUR */}

                        <div className="col-md-2 mb-3">

                            <label>
                                Colour
                            </label>

                            <select
                                className="form-control"
                                name="color"
                                value={categoryForm.color}
                                onChange={handleCategoryChange}
                                required
                            >

                                <option value="">
                                    Select Colour
                                </option>

                                <option value="YELLOW">
                                    Yellow
                                </option>

                                <option value="RED">
                                    Red
                                </option>

                                <option value="WHITE">
                                    White
                                </option>

                                <option value="BLUE">
                                    Blue
                                </option>

                            </select>

                        </div>


                        {/* DESCRIPTION */}

                        <div className="col-md-3 mb-3">

                            <label>
                                Description
                            </label>

                            <input
                                className="form-control"
                                name="description"
                                value={categoryForm.description}
                                onChange={handleCategoryChange}
                            />

                        </div>


                        {/* STATUS */}

                        <div className="col-md-1 mb-3">

                            <label>
                                Status
                            </label>

                            <select
                                className="form-control"
                                name="status"
                                value={categoryForm.status}
                                onChange={handleCategoryChange}
                            >

                                <option value="ACTIVE">
                                    Active
                                </option>

                                <option value="INACTIVE">
                                    Inactive
                                </option>

                            </select>

                        </div>


                        {/* SAVE */}

                        <div className="col-md-1 mb-3 d-flex align-items-end">

                            <button
                                type="submit"
                                className="btn btn-success w-100"
                            >

                                <i className="fa fa-save"></i>

                            </button>

                        </div>

                    </div>

                </form>


                <hr/>


                <DataGrid

                    rows={categories}

                    columns={categoryColumns}

                    autoHeight

                    slots={{
                        toolbar: GridToolbar
                    }}

                    pageSizeOptions={[10, 25, 50]}

                />

            </div>

        </div>)}

        {/* =================================================
                REPORTS
            ================================================= */}

        {tab === "report" && (<div className="row">


            <div className="col-md-3">

                <div className="card text-center shadow-sm">

                    <div className="card-body">

                        <h6>
                            Generated Waste
                        </h6>

                        <h2>
                            {entries.length}
                        </h2>

                    </div>

                </div>

            </div>


            <div className="col-md-3">

                <div className="card text-center shadow-sm">

                    <div className="card-body">

                        <h6>
                            Pickups
                        </h6>

                        <h2>
                            {pickups.length}
                        </h2>

                    </div>

                </div>

            </div>


            <div className="col-md-3">

                <div className="card text-center shadow-sm">

                    <div className="card-body">

                        <h6>
                            Incidents
                        </h6>

                        <h2>
                            {incidents.length}
                        </h2>

                    </div>

                </div>

            </div>


            <div className="col-md-3">

                <div className="card text-center shadow-sm">

                    <div className="card-body">

                        <h6>
                            Active Categories
                        </h6>

                        <h2>
                            {categories.filter(x => x.status === "ACTIVE" || !x.status).length}
                        </h2>

                    </div>

                </div>

            </div>

        </div>)}

    </section>);
}
export default BiomedicalWasteManagement;